import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router';
import moment from 'moment';

interface IRegistrationContext {
    isLoading: boolean
    registration: IRegistration

    updateRegistration: (newRegistration: IRegistration) => void
    deleteRegistration: () => Promise<void>
    restoreRegistration: () => Promise<void>
}
interface LinkedClaim {
    ticketNuber : string
    ticketDate : string
}
export interface IRegistration {
    registrationId: string
    sku: string
    shortDescription: string
    brand: string
    qrCode: string
    serialNumber: string
    isQrCodePresent: boolean
    isQrCodeMandatory: boolean
    unlimited: boolean
    firstName: string
    lastName: string
    email: string
    userCountry: string
    dealerName: string
    dealerCountryCode: string
    dealerCountryName: string
    dealerAddress: string
    receiptUploaded: boolean
    receiptId?: string
    isDeleted: boolean
    receiptDownloadUrl: string
    dealerAllowedCountries: string[]
    qrDealerName: string
    qrDealerCountryCode: string
    qrDealerAllowedCountries: string[]
    status: string
    hasWarrantyExtension: boolean
    isPreGolive: boolean
    extensionMonths: number
    purchaseDate: moment.Moment
    registrationDate: moment.Moment
    legalExpiration: moment.Moment
    warrantyExpiration?: moment.Moment
    warrantyExtensionYears: number
    log: IRegistrationLog[]
    legalMonths: number
    linkedClaims: LinkedClaim[]
}

interface IRegistrationLog {
    userName: string
    logDate: moment.Moment
    log: string
    reason: string
}

export let registrationContext = React.createContext({} as IRegistrationContext);

let { Provider } = registrationContext;

let RegistrationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();

    let [isLoading, setLoading] = useState(true);
    let [registration, setRegistration] = useState({} as IRegistration);


    useEffect(() => {
        getRegistration();
    }, [id])


    let getRegistration = async () => {
        try {
            let res = await axios.get('/api/Product/GetRegistration', { params: { id } });
            let { item } = res.data;
            setRegistration({
                ...item, 
                serialNumber: item.serialNumber || ''
            });

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let deleteRegistration = async () => {
        if (window.confirm("Are you sure that you want to delete this registration?")) {
            try {
                await axios.delete(`/api/Product/DeleteRegistration/${registration.registrationId}`);

                setRegistration({
                    ...registration,
                    isDeleted: true
                })
            } catch (err) { }
        }
    }

    let restoreRegistration = async () => {
        if (window.confirm("Are you sure that you want to restore this deleted registration?")) {
            try {
                await axios.put(`/api/Product/RestoreRegistration/${registration.registrationId}`);

                setRegistration({
                    ...registration,
                    isDeleted: false
                })
            } catch (err) { }
        }
    }

    let updateRegistration = (newRegistration: IRegistration) => {
        setRegistration({
            ...registration,
            ...newRegistration
        })
    }


    return (
        <Provider
            value={{
                isLoading,
                registration,

                updateRegistration,
                deleteRegistration,
                restoreRegistration
            }}
        >
            {children}
        </Provider>
    )
}

export default RegistrationProvider;